import { Button, CircularProgress } from "@mui/material";

export default function CustomButton({
    label,
    variant = "contained",
    loading = false,
    sx = {},
    disabled = false,
    ...props
}) {
    // Common base styles
    const baseStyles = {
        boxShadow: "none",
        color: "#fff",
        border: "none",
        textTransform: "none",
        borderRadius: "10px",
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        transition: "all 0.3s ease",
    };

    // Color styles + hover effects
    const variantStyles = {
        contained: {
            background: "#5bcfc5",
            "&:hover": {
                background: "#4ab3aa", // slightly darker teal
            },
        },
        outlined: {
            background: "#f72b50",
            "&:hover": {
                background: "#d82646", // slightly darker red
            },
        },
    };

    return (
        <Button
            variant={variant}
            sx={{ ...baseStyles, ...variantStyles[variant], ...sx }}
            disabled={loading || disabled}
            {...props}
        >
            {loading && <CircularProgress size={18} color="inherit" />}
            {loading ? "Loading..." : label}
        </Button>
    );
}



// import { Button, CircularProgress } from "@mui/material";

// export default function CustomButton({
//     label,
//     variant = "contained",
//     loading = false,
//     sx = {},
//     disabled = false,
//     ...props
// }) {
//     // Common base styles
//     const baseStyles = {
//         boxShadow: "none",
//         color: "#fff",
//         border: "none",
//         textTransform: "none",
//         borderRadius: "10px",
//         padding: "10px 20px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "8px",
//     };

//     // Color styles by variant
//     const variantStyles = {
//         contained: { background: "#5bcfc5" },
//         outlined: { background: "#f72b50" },
//     };

//     return (
//         <Button
//             variant={variant}
//             sx={{ ...baseStyles, ...variantStyles[variant], ...sx }}
//             disabled={loading || disabled}
//             {...props}
//         >
//             {loading && <CircularProgress size={18} color="inherit" />}
//             {loading ? "Loading..." : label}
//         </Button>
//     );
// }